import _regeneratorRuntime from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { BadPathError, bytesToHex, ConflictError, DoesNotExist, Logger, megabytesToBytes, NotEnoughProofError, PayloadTooLargeError, PreconditionFailedError, utf8ToBytes, ValidationError } from '@stacks/common';
import { compressPrivateKey, ecSign, getPublicKeyFromPrivate, hashSha256Sync, publicKeyToBtcAddress, randomBytes, Signature } from '@stacks/encryption';
import { createFetchFn } from '@stacks/network';
import { fromByteArray } from 'base64-js';
import { TokenSigner } from 'jsontokens';
export var BLOCKSTACK_GAIA_HUB_LABEL = 'blockstack-gaia-hub-config';
export function uploadToGaiaHub(_x, _x2, _x3) {
  return _uploadToGaiaHub.apply(this, arguments);
}

function _uploadToGaiaHub() {
  _uploadToGaiaHub = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(filename, contents, hubConfig) {
    var contentType,
        newFile,
        etag,
        dangerouslyIgnoreEtag,
        fetchFn,
        headers,
        response,
        responseText,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            contentType = _args.length > 3 && _args[3] !== undefined ? _args[3] : 'application/octet-stream';
            newFile = _args.length > 4 && _args[4] !== undefined ? _args[4] : true;
            etag = _args.length > 5 ? _args[5] : undefined;
            dangerouslyIgnoreEtag = _args.length > 6 ? _args[6] : undefined;
            fetchFn = _args.length > 7 && _args[7] !== undefined ? _args[7] : createFetchFn();
            Logger.debug("uploadToGaiaHub: uploading ".concat(filename, " to ").concat(hubConfig.server));
            headers = {
              'Content-Type': contentType,
              Authorization: "bearer ".concat(hubConfig.token)
            };

            if (!dangerouslyIgnoreEtag) {
              if (newFile) {
                headers['If-None-Match'] = '*';
              } else if (etag) {
                headers['If-Match'] = etag;
              }
            }

            _context.next = 10;
            return fetchFn("".concat(hubConfig.server, "/store/").concat(hubConfig.address, "/").concat(filename), {
              method: 'POST',
              headers: headers,
              body: contents
            });

          case 10:
            response = _context.sent;

            if (response.ok) {
              _context.next = 15;
              break;
            }

            _context.next = 14;
            return getBlockstackErrorFromResponse(response, 'Error when uploading to Gaia hub.', hubConfig);

          case 14:
            throw _context.sent;

          case 15:
            _context.next = 17;
            return response.text();

          case 17:
            responseText = _context.sent;
            return _context.abrupt("return", JSON.parse(responseText));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _uploadToGaiaHub.apply(this, arguments);
}

export function deleteFromGaiaHub(_x4, _x5) {
  return _deleteFromGaiaHub.apply(this, arguments);
}

function _deleteFromGaiaHub() {
  _deleteFromGaiaHub = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(filename, hubConfig) {
    var fetchFn,
        response,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fetchFn = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : createFetchFn();
            Logger.debug("deleteFromGaiaHub: deleting ".concat(filename, " from ").concat(hubConfig.server));
            _context2.next = 4;
            return fetchFn("".concat(hubConfig.server, "/delete/").concat(hubConfig.address, "/").concat(filename), {
              method: 'DELETE',
              headers: {
                Authorization: "bearer ".concat(hubConfig.token)
              }
            });

          case 4:
            response = _context2.sent;

            if (response.ok) {
              _context2.next = 9;
              break;
            }

            _context2.next = 8;
            return getBlockstackErrorFromResponse(response, 'Error deleting file from Gaia hub.', hubConfig);

          case 8:
            throw _context2.sent;

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _deleteFromGaiaHub.apply(this, arguments);
}

export function getFullReadUrl(filename, hubConfig) {
  return Promise.resolve("".concat(hubConfig.url_prefix).concat(hubConfig.address, "/").concat(filename));
}

function makeLegacyAuthToken(challengeText, signerKeyHex) {
  var parsedChallenge;

  try {
    parsedChallenge = JSON.parse(challengeText);
  } catch (err) {
    throw new Error('Failed in parsing legacy challenge text from the gaia hub.');
  }

  if (parsedChallenge[0] === 'gaiahub' && parsedChallenge[3] === 'blockstack_storage_please_sign') {
    var digest = hashSha256Sync(utf8ToBytes(challengeText));
    var signatureBytes = ecSign(digest, compressPrivateKey(signerKeyHex));
    var signature = Signature.fromCompact(bytesToHex(signatureBytes)).toDERHex();
    var publickey = getPublicKeyFromPrivate(signerKeyHex);
    var token = fromByteArray(utf8ToBytes(JSON.stringify({
      publickey: publickey,
      signature: signature
    })));
    return token;
  }

  throw new Error('Failed to connect to legacy gaia hub. If you operate this hub, please update.');
}

function makeV1GaiaAuthToken(hubInfo, signerKeyHex, hubUrl, associationToken) {
  var challengeText = hubInfo.challenge_text;
  var handlesV1Auth = hubInfo.latest_auth_version && parseInt(hubInfo.latest_auth_version.slice(1), 10) >= 1;
  var iss = getPublicKeyFromPrivate(signerKeyHex);

  if (!handlesV1Auth) {
    return makeLegacyAuthToken(challengeText, signerKeyHex);
  }

  var salt = bytesToHex(randomBytes(16));
  var payload = {
    gaiaChallenge: challengeText,
    hubUrl: hubUrl,
    iss: iss,
    salt: salt,
    associationToken: associationToken
  };
  var token = new TokenSigner('ES256K', signerKeyHex).sign(payload);
  return "v1:".concat(token);
}

export function connectToGaiaHub(_x6, _x7, _x8) {
  return _connectToGaiaHub.apply(this, arguments);
}

function _connectToGaiaHub() {
  _connectToGaiaHub = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(gaiaHubUrl, challengeSignerHex, associationToken) {
    var fetchFn,
        response,
        hubInfo,
        readURL,
        token,
        address,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            fetchFn = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : createFetchFn();
            Logger.debug("connectToGaiaHub: ".concat(gaiaHubUrl, "/hub_info"));
            _context3.next = 4;
            return fetchFn("".concat(gaiaHubUrl, "/hub_info"));

          case 4:
            response = _context3.sent;
            _context3.next = 7;
            return response.json();

          case 7:
            hubInfo = _context3.sent;
            readURL = hubInfo.read_url_prefix;
            token = makeV1GaiaAuthToken(hubInfo, challengeSignerHex, gaiaHubUrl, associationToken);
            address = publicKeyToBtcAddress(getPublicKeyFromPrivate(challengeSignerHex));
            return _context3.abrupt("return", {
              url_prefix: readURL,
              max_file_upload_size_megabytes: hubInfo.max_file_upload_size_megabytes,
              address: address,
              token: token,
              server: gaiaHubUrl
            });

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _connectToGaiaHub.apply(this, arguments);
}

export function getBucketUrl(_x9, _x10) {
  return _getBucketUrl.apply(this, arguments);
}

function _getBucketUrl() {
  _getBucketUrl = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(gaiaHubUrl, appPrivateKey) {
    var fetchFn,
        response,
        responseText,
        responseJSON,
        readURL,
        address,
        bucketUrl,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            fetchFn = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : createFetchFn();
            _context4.next = 3;
            return fetchFn("".concat(gaiaHubUrl, "/hub_info"));

          case 3:
            response = _context4.sent;
            _context4.next = 6;
            return response.text();

          case 6:
            responseText = _context4.sent;
            responseJSON = JSON.parse(responseText);
            readURL = responseJSON.read_url_prefix;
            address = publicKeyToBtcAddress(getPublicKeyFromPrivate(appPrivateKey));
            bucketUrl = "".concat(readURL).concat(address, "/");
            return _context4.abrupt("return", bucketUrl);

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getBucketUrl.apply(this, arguments);
}

function getGaiaErrorResponse(_x11) {
  return _getGaiaErrorResponse.apply(this, arguments);
}

function _getGaiaErrorResponse() {
  _getGaiaErrorResponse = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(response) {
    var responseMsg, responseJson, status, statusText, body;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            responseMsg = '';
            _context5.prev = 1;
            _context5.next = 4;
            return response.text();

          case 4:
            responseMsg = _context5.sent;

            try {
              responseJson = JSON.parse(responseMsg);
            } catch (error) {}

            _context5.next = 11;
            break;

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](1);
            Logger.debug("Error getting bad http response text: ".concat(_context5.t0));

          case 11:
            status = response.status;
            statusText = response.statusText;
            body = responseJson || responseMsg;
            return _context5.abrupt("return", {
              status: status,
              statusText: statusText,
              body: body
            });

          case 15:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 8]]);
  }));
  return _getGaiaErrorResponse.apply(this, arguments);
}

export function getBlockstackErrorFromResponse(_x12, _x13, _x14) {
  return _getBlockstackErrorFromResponse.apply(this, arguments);
}

function _getBlockstackErrorFromResponse() {
  _getBlockstackErrorFromResponse = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(response, errorMsg, hubConfig) {
    var gaiaResponse, maxBytes;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!response.ok) {
              _context6.next = 2;
              break;
            }

            throw new Error('Cannot get a BlockstackError from a valid response.');

          case 2:
            _context6.next = 4;
            return getGaiaErrorResponse(response);

          case 4:
            gaiaResponse = _context6.sent;

            if (!(gaiaResponse.status === 401)) {
              _context6.next = 9;
              break;
            }

            return _context6.abrupt("return", new ValidationError(errorMsg, gaiaResponse));

          case 9:
            if (!(gaiaResponse.status === 402)) {
              _context6.next = 13;
              break;
            }

            return _context6.abrupt("return", new NotEnoughProofError(errorMsg, gaiaResponse));

          case 13:
            if (!(gaiaResponse.status === 403)) {
              _context6.next = 17;
              break;
            }

            return _context6.abrupt("return", new BadPathError(errorMsg, gaiaResponse));

          case 17:
            if (!(gaiaResponse.status === 404)) {
              _context6.next = 21;
              break;
            }

            throw new DoesNotExist(errorMsg, gaiaResponse);

          case 21:
            if (!(gaiaResponse.status === 409)) {
              _context6.next = 25;
              break;
            }

            return _context6.abrupt("return", new ConflictError(errorMsg, gaiaResponse));

          case 25:
            if (!(gaiaResponse.status === 412)) {
              _context6.next = 29;
              break;
            }

            return _context6.abrupt("return", new PreconditionFailedError(errorMsg, gaiaResponse));

          case 29:
            if (!(gaiaResponse.status === 413)) {
              _context6.next = 34;
              break;
            }

            maxBytes = hubConfig && hubConfig.max_file_upload_size_megabytes ? megabytesToBytes(hubConfig.max_file_upload_size_megabytes) : 0;
            return _context6.abrupt("return", new PayloadTooLargeError(errorMsg, gaiaResponse, maxBytes));

          case 34:
            return _context6.abrupt("return", new Error(errorMsg));

          case 35:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getBlockstackErrorFromResponse.apply(this, arguments);
}